import { useCallback } from 'react';
import type { ListViewIssuesReturn as QueryData } from '../../../services/get-list-view-issues/types.tsx';
import { useIssueFields } from '../../get-issue-fields/index.tsx';
import { useRowCreateStore } from '../../row-create/index.tsx';
import { useHierarchyStore } from '../hierarchy-store/index.tsx';

export const useSetChildrenItems = () => {
	const [, { setChildrenItems }] = useHierarchyStore();
	const [rowCreateState, { setRowCreatePosition }] = useRowCreateStore();
	const { hierarchyLevelsWithCache } = useIssueFields();

	const setChildrenItemsWithDependencies = useCallback(
		(parentIssueId: string, queryData: QueryData) =>
			setChildrenItems(
				parentIssueId,
				queryData,
				rowCreateState,
				setRowCreatePosition,
				hierarchyLevelsWithCache,
			),
		[setChildrenItems, rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache],
	);

	return { setChildrenItems: setChildrenItemsWithDependencies };
};
